import { Button } from '@leasequery/lq.react-component-library';
import React from 'react'
import styled from 'styled-components';

interface RefreshPanelProps {
    onClose: () => void,
    onRefresh: () => void
}

const MainContainer = styled.div`
height: 10rem;
background-color: white;
width: 92%;
margin: 0 1rem 0 1rem;
border: 0.2rem solid #FFA540;
border-radius: 0.8rem;
`;

const CloseSection = styled.div`
height: 2rem;
`;

const CloseButtonContainer = styled.div`
float: right;
margin-right: 0.5rem;
color: gray;
`;

const CloseButton = styled.img`
width: 1.2rem;
height: 1.2rem;
cursor: pointer;
`;

const ContentSection = styled.div`
margin: 0rem 0.4rem 1rem 0.4rem;
`;

const WarningSection = styled.div`
float: left;
width: 10%;
margin-top: 1rem;
`;

const TextSection = styled.div`
float: left;
width: 50%;
padding-bottom: 1rem;
`;

const TextSubsection = styled.div`
font-weight: bold;
`;

const RefreshButtonSection = styled.div`
float: left;
width: 40%; 
margin-top: 1rem;
text-align: center;
`;

const WarningIcon = styled.img`
width: 2.4rem;
height: 2.4rem;
`;

function RefreshPanel({
    onClose,
    onRefresh
}:RefreshPanelProps) : JSX.Element {
    return (
        <MainContainer>
            <CloseSection>
                <CloseButtonContainer>
                    <CloseButton src="/static/images/close.svg" onClick={() => onClose()} />
                </CloseButtonContainer>
            </CloseSection>
            <ContentSection>
                <WarningSection><WarningIcon src='/static/images/warning.svg' /></WarningSection>
                <TextSection>
                    <TextSubsection>Can&apos;t find a field?</TextSubsection>
                    The page may need to be refreshed.
                </TextSection>
                <RefreshButtonSection>
                    <Button onClick={() => onRefresh()} size='sm'>Refresh</Button>
                </RefreshButtonSection>
            </ContentSection>
        </MainContainer>
    );
}

export default RefreshPanel;
